import { useEffect } from 'react';
import Lenis from 'lenis';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Hero from './sections/Hero';
import Marquee from './components/eclora/Marquee';
import Identification from './sections/Identification';
import Benefits from './sections/Benefits';
import Journey from './sections/Journey';
import Founder from './sections/Founder';
import Steps from './sections/Steps';
import FinalCta from './sections/FinalCta';
import Footer from './sections/Footer';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import Confirmation from './pages/Confirmation';

function Landing() {
    return (
        <>
            <Hero />
            <Marquee />
            <Identification />
            <Benefits />
            <Journey />
            <Founder />
            <Steps />
            <FinalCta />
            <Footer />
        </>
    );
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
        return () => lenis.destroy();
    }, []);

    return (
        <BrowserRouter>
            <main className="overflow-x-clip bg-creme font-sans text-cacao antialiased">
                <div className="grain-overlay" aria-hidden="true" />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/confirmation" element={<Confirmation />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
                </Routes>
            </main>
        </BrowserRouter>
    );
}
